<template>
	<div class="container">
		<div class="row clearfix">
			<div v-if="contact.form_name !== null" class="column full">
				<h3 class="iv2-contact-form__title">{{ contact.form_name }}</h3>
			</div>
			<div v-if="contact.form_description !== null" class="column full">
				<p
					class="iv2-contact-form__sumally text-pre"
					v-if="contact.form_description !== null"
					style="letter-spacing: 3px;"
				>{{ contact.form_description }}</p>
			</div>
			<div class="column full">
				<div class="spacer height-20"></div>
			</div>
			<form @submit.prevent="submit">
				<loading
					:active.sync="isLoading"
					:can-cancel="false"
					:on-cancel="onCancel"
					:is-full-page="fullPage"
					:background-color="bgColor"
				></loading>
				<div v-if="success" class="iv2-contact-form__response-text text-pre">{{ $t('contact.send_text') }}</div>
				<div v-else-if="timeout" class="iv2-contact-form__response-text text-pre">{{ $t('contact.send_error') }}</div>
				<div v-else-if="invalid" class="m-4 text-danger text-pre">{{ $t('contact.send_invalid') }}</div>
				<div class="column full">
					<label class="d-block mt-3">
						<span class="badge badge-danger mr-2">{{ $t('general.required') }}</span>
						<span>{{ $t('contact.business_company') }}</span>
					</label>
					<input
						type="text"
						class="iv2-contact-form__item w-75 p-2"
						name="company"
						id="company"
						v-model="fields.company"
						:placeholder="$t('contact.business_company')"
					/>
					<div v-if="errors && errors.company" class="text-danger">{{ errors.company[0] }}</div>
				</div>
				<div class="column full">
					<label class="d-block mt-3">
						<span class="badge badge-danger mr-2">{{ $t('general.required') }}</span>
						<span>{{ $t('contact.business_name') }}</span>
					</label>
					<input
						type="text"
						class="iv2-contact-form__item w-75 p-2"
						name="name"
						id="name"
						v-model="fields.name"
						:placeholder="$t('contact.business_name')"
					/>
					<div v-if="errors && errors.name" class="text-danger">{{ errors.name[0] }}</div>
				</div>
				<div class="column full">
					<label class="d-block mt-3">
						<span class="badge badge-info mr-2">{{ $t('general.any') }}</span>
						<span>{{ $t('contact.tel') }}</span>
					</label>
					<input
						type="tel"
						class="iv2-contact-form__item w-75 p-2"
						name="tel"
						id="tel"
						v-model="fields.tel"
						:placeholder="$t('contact.tel')"
					/>
					<div v-if="errors && errors.tel" class="text-danger">{{ errors.tel[0] }}</div>
				</div>
				<div class="column full">
					<label class="d-block mt-3">
						<span class="badge badge-danger mr-2">{{ $t('general.required') }}</span>
						<span>{{ $t('contact.email') }}</span>
					</label>
					<input
						type="email"
						class="iv2-contact-form__item w-75 p-2"
						name="email"
						id="email"
						v-model="fields.email"
						:placeholder="$t('contact.email')"
					/>
					<div v-if="errors && errors.email" class="text-danger">{{ errors.email[0] }}</div>
				</div>
				<div class="column full">
					<label class="d-block mt-3">
						<span class="badge badge-danger mr-2">{{ $t('general.required') }}</span>
						<span>{{ $t('contact.method.text') }}</span>
					</label>
					<label v-for="method in $t('contact.method.list')" :key="method.id" class="mb-0 mr-1">
						<input
							type="radio"
							class="iv2-contact-form__item m-2"
							name="method"
							:value="method.value"
							v-model="fields.method"
						/>
						{{method.name}}
					</label>
					<div v-if="errors && errors.method" class="text-danger">{{ errors.method[0] }}</div>
					<p class="mt-1 mb-1">{{ $t('contact.method.warning') }}</p>
				</div>
				<div class="column full">
					<label class="d-block mt-3">
						<span class="badge badge-info mr-2">{{ $t('general.any') }}</span>
						<span>{{ $t('contact.title') }}</span>
					</label>
					<input
						type="text"
						class="iv2-contact-form__item w-75 p-2"
						name="title"
						id="title"
						v-model="fields.title"
						:placeholder="$t('contact.title')"
					/>
					<!-- <div v-if="errors && errors.title" class="text-danger">{{ errors.title[0] }}</div> -->
				</div>
				<div class="column full">
					<label class="d-block mt-3">
						<span class="badge badge-danger mr-2">{{ $t('general.required') }}</span>
						<span>{{ $t('contact.message') }}</span>
					</label>
					<textarea
						class="iv2-contact-form__item w-100 p-2"
						id="message"
						name="message"
						rows="5"
						v-model="fields.message"
					></textarea>
					<div v-if="errors && errors.message" class="text-danger">{{ errors.message[0] }}</div>
				</div>
				<div class="column full">
					<p class="text-center text-pre mb-4">{{ $t('contact.warning') }}</p>
					<div v-if="is_agreement == 1">
						<p class="text-center mb-0">
							<router-link
								to="/privacypolicy"
								target="_blank"
								class="iv2-contact__privacy-link"
							>{{ $t('contact.privacy_link') }}</router-link>
							{{ $t('contact.privacy_text') }}
						</p>
						<div class="text-center">
							<label style="cursor: pointer;">
								<input type="checkbox" name="agreement" id="agreement" v-model="fields.agreement" />
								{{ $t('contact.agreement') }}
								<div v-if="errors && errors.agreement" class="text-danger">{{ errors.agreement[0] }}</div>
							</label>
						</div>
					</div>
					<p class="text-center mt-5">
						<input
							class="iv2-contact-form__btn theme__main-btn"
							type="submit"
							:value="$t('contact.button')"
							:disabled="!fields.agreement"
						/>
					</p>
					<div class="spacer height-100"></div>
				</div>
				<div v-if="is_agreement == 0">
					<input type="hidden" v-model="fields.agreement">
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
	components: {
		Loading,
	},

	props: ["contact"],
	data() {
		return {
			fields: {
				company: "",
				name: "",
				email: "",
				tel: "",
				method: "",
				title: "",
				message: "",
				agreement: ""
			},
			errors: {},
			is_agreement: "",
			success: false,
			timeout: false,
			invalid: false,
			loaded: true,
			fullPage: true,
			isLoading: false,
			bgColor: "#525252",
		};
	},

	mounted() {
		this.axios.get("/pages/privacypolicy/show").then((response) => {
			this.is_agreement = response.data.response.open_type;
			if(this.is_agreement == 0) {
				this.fields.agreement = true
			}else{
				this.fields.agreement = ""
			}
		})
	},

	methods: {
		submit() {
			this.isLoading = true;

			setTimeout(() => {
				this.loaded = true;
				if (this.isLoading === true) {
					window.scrollTo({
						top: 0,
						behavior: "smooth",
					});
					this.timeout = true;
					this.isLoading = false;
					// console.log("loading timeout");
				}
			}, 30000);

			if (this.loaded) {
				this.loaded = false;
				this.success = false;
				this.timeout = false;
				this.invalid = false;
				this.errors = {};

				this.axios
					.post('/contacts/' + process.env.VUE_APP_CONTACT_BIZ,
						this.fields,
						{
							withCredentials: true,
						}
					)

					.then(() => {
						this.fields = {
							company: "",
							name: "",
							email: "",
							tel: "",
							method: "",
							title: "",
							message: "",
						}; //Clear input fields.
						if(this.is_agreement == 0) {
							this.fields.agreement = true
						}else{
							this.fields.agreement = ""
						}
						this.loaded = true;
						this.success = true;
						this.isLoading = false;
						window.scrollTo({
							top: 0,
							behavior: "smooth",
						});
						// console.log(response);
					})
					.catch((error) => {
						this.loaded = true;
						if (error.response.status === 422) {
							this.errors = error.response.data.errors || {};
							this.invalid = true;
						}else{
							this.timeout = true;
						}
						this.isLoading = false;
						window.scrollTo({
							top: 0,
							behavior: "smooth",
						});
					});
			}
		},
		onCancel() {
			// console.log("User cancelled the loader.");
		},
	},
};
</script>

<style lang="scss">
.iv2-contact-form__response-text {
	background-color: #ddd;
	color: #000;
	margin: 1rem 0;
	padding: 0.75rem 1.25rem;
	border-radius: 5px;
}

.iv2-contact-form__item {
	border: 1px solid #8c8c8c;
}

.iv2-contact-form__btn {
	text-align: center;
	display: inline-block;
	border: 0;
	letter-spacing: 2px;
	padding-top: 15px;
	padding-bottom: 15px;
	border-radius: 0;
	width: 300px;
	max-width: 100%;
}

input[type="submit"][disabled] {
  opacity: .2;

	&:hover {
		transform: scale(1);
		opacity: .2;
	}
}

@media (max-width: 1199px) {
	.iv2-contact__privacy-link {
		text-decoration: underline;
	}
}
</style>
